import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { BRAND, SERVICES, HOURS, IMAGES } from "../data/content";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteDataContext = createContext();

export const resolveUrl = (u) => (u && u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

const defaultGallery = IMAGES.gallery.map((url, i) => ({ id: `d${i}`, url }));

export const SiteDataProvider = ({ children }) => {
  const [services, setServices] = useState(SERVICES);
  const [hours, setHours] = useState(HOURS);
  const [gallery, setGallery] = useState(defaultGallery);
  const [products, setProducts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [social, setSocial] = useState(BRAND);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      if (data.services) setServices(data.services);
      if (data.hours) setHours(data.hours);
      if (Array.isArray(data.gallery) && data.gallery.length) {
        setGallery(data.gallery.map((g) => ({ id: g.id, url: resolveUrl(g.url) })));
      }
      if (Array.isArray(data.products)) {
        setProducts(data.products.map((p) => ({ ...p, image: resolveUrl(p.image) })));
      }
      if (Array.isArray(data.reviews)) setReviews(data.reviews);
      if (data.social) setSocial({ ...BRAND, ...data.social });
    } catch (e) {
      // keep defaults on failure
    }
  };

  useEffect(() => {
    load();
    // track a visit once per browser session
    try {
      if (!sessionStorage.getItem("slaly_visited")) {
        sessionStorage.setItem("slaly_visited", "1");
        axios.post(`${API}/visit`).catch(() => {});
      }
    } catch (e) {}
  }, []);

  const brand = { ...BRAND, ...social };

  return (
    <SiteDataContext.Provider value={{ services, hours, gallery, products, reviews, brand, reload: load }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => useContext(SiteDataContext);
export { API };
